var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "group_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".group_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "group_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "group_svg__st1",
    d: "M7.99 15.21c1.81-.42 2.87-.78 2.05-2.33C7.56 8.19 9.38 5.67 12 5.67c2.67 0 4.46 2.6 1.96 7.2-.84 1.55.28 1.92 2.05 2.33 1.57.36 1.67 1.13 1.67 2.46v.65H6.31c.01-1.73-.13-2.68 1.68-3.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "group_svg__st1",
    d: "M0 18.32h4.93c-.02-5.16 2.17-3.36 2.17-7.03 0-1.59-1.04-2.45-2.37-2.45-1.97 0-3.34 1.88-1.47 5.4.61 1.16-.65 1.43-2.01 1.74-1.18.27-1.25.85-1.25 1.84v.5zM24 17.83c0-1-.08-1.57-1.25-1.84-1.36-.31-2.62-.59-2.01-1.74 1.86-3.52.49-5.4-1.47-5.4-1.33 0-2.37.86-2.37 2.45 0 3.67 2.19 1.86 2.17 7.03H24v-.5z"
  })));
};
export default SvgGroup;